import { Outlet } from 'react-router-dom'
import { SettingsNav } from './SettingsNav'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/**
 * Каркас раздела настроек. До этой задачи его не было вовсе:
 * `settings/connections` был единственным маршрутом и рисовался без оболочки, а
 * пункты «Аккаунт»/«Уведомления»/«Настройки» в меню профиля стояли «Скоро».
 */
export const SettingsLayout = () => {
  const m = useMessages(messages)
  return (
    <div className="mx-auto w-full max-w-5xl px-4 py-8 xl:max-w-6xl wide:max-w-7xl">
      <h1 className="mb-6 text-2xl font-semibold">{m.title}</h1>
      <div className="flex flex-col gap-6">
        <SettingsNav />
        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
